import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { Button } from 'src/common/Button/Button.tsx';
import { DeleteIcon } from 'src/modules/common/icons/DeleteIcon.tsx';
import clsx from 'clsx';
import { Price } from 'src/common/Price/Price.tsx';
import { UserSettings } from 'src/types/UserSettings.ts';
import { SensorsAccessoriesPageData } from 'src/sensors/accessories/SensorsAccessoriesPageMapping.ts';
import { Accessory as AccessoryType } from 'src/common/prepareAccessories.ts';
import { Accessory } from 'src/common/Accessory/Accessory.tsx';
import { Counter } from 'src/common/Counter/Counter.tsx';

type Props = {
    isSelected: boolean;
    removePipeConnectors: () => void;
    pipeConnectors: AccessoryType<SensorsAccessoriesPageData['accessories']['accessories']['0']>[];
    isCheckoutViewOnly: boolean;
    userSettings: UserSettings;
    sensorQty: number;
    currentCurrency: string;
    onChange: (name: string, value: number) => void;
    onDelete: (name: string) => void;
}

export const PipeConnectorsView = ({
    isSelected,
    removePipeConnectors,
    pipeConnectors,
    isCheckoutViewOnly,
    userSettings,
    sensorQty,
    currentCurrency,
    onChange,
    onDelete,
} : Props) => (
    <>
        <div className="vss-checkout-page__subtitle-wrapper">
            <h2 className="vss-checkout-page__subtitle">
                <I18n messageId={MESSAGES.PipeConnectors}/>
            </h2>
            {isSelected && pipeConnectors.length > 1 && (
                <Button
                    iconOnly={true}
                    kind="ghost-secondary"
                    onClick={removePipeConnectors}
                >
                    <div className="vss-checkout-page__icon-wrapper">
                        <DeleteIcon/>
                    </div>
                </Button>
            )}
        </div>

        <div className={clsx({
            'vss-checkout-page__selected-devices': true,
            'vss-checkout-page__selected-devices--single': pipeConnectors.length === 1,
        })}
        >
            {pipeConnectors.map(({ accessory, price, qty }) => {
                const { item } = accessory;
                const pipeConnectorQty = qty / sensorQty;
                return (
                    <Accessory
                        accessory={item}
                        key={`${item.Label}-${item.ID}`}
                        price={isCheckoutViewOnly ? '\u2014' : (
                            <Price
                                price={price}
                                currency={currentCurrency}
                                locale={userSettings.currentLocale}
                            />
                        )}
                        counter={(
                            <Counter
                                value={qty}
                                onChange={(value) => onChange(item.Label, value)}
                            />
                        )}
                        qty={isSelected ? `${pipeConnectorQty}x` : undefined}
                        theme="white"
                    >
                        <div className="vss-checkout-page__action-wrapper">
                            <div className="vss-checkout-page__price-wrapper">
                                <Button
                                    kind="ghost-secondary"
                                    iconOnly={true}
                                    onClick={() => onDelete(item.Label)}
                                >
                                    <div className="vss-checkout-page__icon-wrapper">
                                        <DeleteIcon/>
                                    </div>
                                </Button>
                            </div>
                        </div>
                    </Accessory>
                );
            })}
        </div>
    </>
);
